if (!customElements.get('complementary-slider')) {
  class ComplementarySlider extends HTMLElement {
    constructor() {
      super();
      this.track = null;
      this.prevBtn = null;
      this.nextBtn = null;
    }

    connectedCallback() {
      const rec = this.closest('product-recommendations');
      if (rec) {
        const observer = new MutationObserver(() => {
          if (this.querySelector('.complementary-track')) {
            this.init();
            observer.disconnect();
          }
        });
        observer.observe(rec, { childList: true, subtree: true });
      }
      this.init();
    }

    init() {
      this.track = this.querySelector('.complementary-track');
      this.prevBtn = this.querySelector('.complementary-nav-arrow--prev');
      this.nextBtn = this.querySelector('.complementary-nav-arrow--next');

      if (!this.track) return;
      if (this.prevBtn) this.prevBtn.addEventListener('click', this.onPrevClick.bind(this));
      if (this.nextBtn) this.nextBtn.addEventListener('click', this.onNextClick.bind(this));
      this.initDrag();
    }

    initDrag() {
      const track = this.track;
      let dragging = false, didDrag = false, startX, scrollStart;
      track.style.cursor = 'grab';
      track.addEventListener('mousedown', (e) => {
        dragging = true; didDrag = false; startX = e.pageX; scrollStart = track.scrollLeft;
        track.style.cursor = 'grabbing'; track.style.scrollSnapType = 'none'; e.preventDefault();
      });
      document.addEventListener('mousemove', (e) => {
        if (!dragging) return;
        if (Math.abs(e.pageX - startX) > 5) didDrag = true;
        track.scrollLeft = scrollStart - (e.pageX - startX);
      });
      document.addEventListener('mouseup', () => {
        if (!dragging) return; dragging = false;
        track.style.cursor = 'grab'; track.style.scrollSnapType = 'x mandatory';
        if (didDrag) setTimeout(() => { didDrag = false; }, 0);
      });
      track.addEventListener('click', (e) => {
        if (didDrag) { e.preventDefault(); e.stopPropagation(); }
      }, true);
    }

    getScrollAmount() {
      const item = this.track.querySelector('.complementary-track__item');
      if (!item) return 0;
      return item.offsetWidth + parseFloat(getComputedStyle(this.track).gap || 0);
    }

    onPrevClick() {
      this.track.scrollBy({ left: -this.getScrollAmount(), behavior: 'smooth' });
    }

    onNextClick() {
      this.track.scrollBy({ left: this.getScrollAmount(), behavior: 'smooth' });
    }
  }

  customElements.define('complementary-slider', ComplementarySlider);
}
